import axios from "axios";

export default {
    namespaced: true,
    state: {
        settings: {
            show_filters: false,
            show_search: false,
            show_preloded: true,
            shared: false, // social sharing need object
            header_class: ""
        },
        preloaded: {},
        real_url: "https://abmcocktailpro.com", // without last slash
        api_url: "https://abmcocktailpro.com/api/"
    },
    mutations: {
        setShareLinks(state,val){
            state.settings.shared = val
        },
        changeHeaderClass(state,val){
            state.settings.header_class = val;
        },
        showPreloader(state){
            state.show_preloded = true
        }
    },
    actions: {
        getData(store) {
            axios.get(store.state.api_url + "get-data")
                    .then((response) => {
                        console.log(response.data);
                        store.state.preloaded = response.data;
                        store.state.settings.show_preloded = false;
                        console.log('heres stored preloaded');
                        console.log(store.state.preloaded);

                        store.commit("search/setFilters", { id: 0, name:'Filters', spanish_name:'Filtros', sorted:false, children: unflatten(store.state.preloaded.filters) }, {root: true});

                    })
                    .catch(function (error) {
                        // handle error
                        console.log(error);
                    })
                    .finally(function () {
                        // always executed
                    })
        },
    },
    getters: {}
}


function unflatten(arr) {
    var tree = [],
            mappedArr = {},
            arrElem,
            mappedElem;

    // First map the nodes of the array to an object -> create a hash table.
    for(var i = 0, len = arr.length; i < len; i++) {
        arrElem = arr[i];
        mappedArr[arrElem.id] = arrElem;
        mappedArr[arrElem.id]['children'] = [];
    }


    for (var id in mappedArr) {
        if (mappedArr.hasOwnProperty(id)) {
            mappedElem = mappedArr[id];
            // If the element is not at the root level, add it to its parent array of children.
            if (mappedElem.parent) {
                mappedArr[mappedElem['parent']]['children'].push(mappedElem);
            }
            // If the element is at the root level, add it to first level elements array.
            else {
                tree.push(mappedElem);
            }
        }
    }
    return tree;
}
